import styled from 'styled-components';
import { Box } from '@mui/material';
import colors from '../../../../../styles/colors';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const LeadModalContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
`;

const HeaderBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 2;
`;

const FooterButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 20px;
  width: 100%;
  background-color: ${colors.shades.secondary10};
`;
export {
  Container,
  LeadModalContainer,
  HeaderBar,
  FooterButtonsContainer,
};
